export default function Portfolio() {
  const portfolioItems = [
    {
      id: 1,
      title: 'Thumbnail Design',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/adb299a68ac8567c9295d1ebc3e5edb2.jpeg',
    },
    {
      id: 2,
      title: 'Thumbnail Design 2',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/d194a855769de093337443d58f244ff5.jpeg',
    },
    {
      id: 3,
      title: 'Thumbnail Design 3',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/b415ac492ae65fd3c55f620d2065c73c.jpeg',
    },
    {
      id: 4,
      title: 'Thumbnail Design 4',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/e231a181eaac7abce8c6d4b4e6fb1a86.jpeg',
    },
    {
      id: 5,
      title: 'Thumbnail Design 5',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/5563dd040eb739510f4fee49c947196d.png',
    },
    {
      id: 6,
      title: 'Thumbnail Design 6',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/32d7a51dc5f236d307b639061e9611aa.jpeg',
    },
    {
      id: 7,
      title: 'Thumbnail Design 7',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/c90e7a5fe2b1c71e821353ed88970726.jpeg',
    },
    {
      id: 8,
      title: 'Thumbnail Design 8',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/ecaac372d0db23f3b9b0e8356a65d00f.jpeg',
    },
    {
      id: 9,
      title: 'Thumbnail Design 9',
      image: 'https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/d9063057d10f15fdbcc2fb5e79d500ca.jpeg',
    },
  ];

  return (
    <section id="portfolio" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">
            My Portfolio
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Explore my latest thumbnail designs and creative works
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {portfolioItems.map((item) => (
            <div
              key={item.id}
              className="group relative aspect-video bg-gradient-to-br from-purple-900/30 to-pink-900/30 rounded-2xl border border-purple-500/20 hover:border-purple-500/50 overflow-hidden transition-all duration-500 hover:scale-105 cursor-pointer"
            >
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>
              
              {/* Content */}
              {'image' in item ? (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="relative z-10 w-full h-full flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl shadow-lg">
                      <i className="ri-image-line text-3xl"></i>
                    </div>
                    <h3 className="text-lg font-semibold text-white group-hover:text-purple-300 transition-colors duration-300">
                      {item.title}
                    </h3>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
